import * as z from 'zod';

import { PrematchTableType } from '../constants/prematchTableType';

import OutcomeSchema from './OutcomeSchema';
import TableRowColorsSchema from './TableRowColorsSchema';

export const TableTabResponseTypeSchema = z.enum([
  PrematchTableType.TABLE,
  PrematchTableType.GROUP_TABLE,
  PrematchTableType.KNOCKOUT,
]);

export const PrematchTableColorLegendItemSchema = z.object({
  color: TableRowColorsSchema,
  label: z.string(),
  description: z.string(),
});

export const PrematchTableRowSchema = z.object({
  no: z.number(),
  teamName: z.string(),
  leagueName: z.string(),
  playedMatches: z.number(),
  wins: z.number(),
  draws: z.number(),
  losses: z.number(),
  points: z.number(),
  form: z.array(OutcomeSchema),
  qualification: z.string().nullable(),
  color: TableRowColorsSchema.nullable(),
  inPlay: z.boolean(),
  jersey: z.string().nullable(),
  flag: z.string().nullable(),
});

export const PrematchTableGroupSchema = z.object({
  groupName: z.string(),
  tableRows: z.array(PrematchTableRowSchema),
});

export const KnockoutMatchProgressSchema = z.object({
  completed_matches: z.number(),
  total_matches: z.number(),
  is_multi_leg: z.boolean(),
});

export const KnockoutMatchSchema = z.object({
  home_team: z.string().nullable(),
  away_team: z.string().nullable(),
  home_jersey: z.string().nullable(),
  away_jersey: z.string().nullable(),
  home_flag: z.string().nullable(),
  away_flag: z.string().nullable(),
  home_score: z.number().nullable(),
  away_score: z.number().nullable(),
  first_leg_home_score: z.number().nullable(),
  first_leg_away_score: z.number().nullable(),
  date: z.string().nullable(),
  home_penalty_score: z.number().nullable(),
  away_penalty_score: z.number().nullable(),
});

export const KnockoutStageSchema = z.object({
  stage_type: z.string(),
  is_current_stage: z.boolean(),
  matches: z.array(KnockoutMatchSchema),
});

export const TableTabResponseSchema = z.object({
  type: TableTabResponseTypeSchema,
  tableRows: z.array(PrematchTableRowSchema).nullable(),
  groups: z.array(PrematchTableGroupSchema).nullable(),
  colorLegend: z.array(PrematchTableColorLegendItemSchema).nullable(),
  totalTeams: z.number().nullable(),
  totalGroups: z.number().nullable(),
  leagueName: z.string(),
  knockout: z.array(KnockoutStageSchema).nullable(),
});
